import { createRequestActions } from "common/helpers/action";

export const initCpOffers = createRequestActions("CP.OFFER.LIST.INIT");

export const editCpUserType = createRequestActions("CP.USER_TYPE.EDIT");
export const deleteCpUserType = createRequestActions("CP.USER_TYPE.DELETE");

export const editCpDoc = createRequestActions("CP.DOC.EDIT");
export const deleteCpDoc = createRequestActions("CP.DOC.DELETE");
